"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIVE_MINUTES = exports.FIFTY_FIVE_MINUTES = void 0;
exports.FIFTY_FIVE_MINUTES = 3300000;
exports.FIVE_MINUTES = 300000;
//# sourceMappingURL=constants.js.map